"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Root;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

//
function Root(_ref) {
  var children = _ref.children;

  var ResolvedRoot = _react["default"].useMemo(function () {
    return _.plugins.Root(function (_ref2) {
      var children = _ref2.children;
      return children;
    });
  }, [_.plugins]);

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      error = _React$useState2[0],
      setError = _React$useState2[1];

  _react["default"].useEffect(function () {
    if (module && module.hot) {
      var hotReloadHandler = function hotReloadHandler(status) {
        if (status === 'idle') {
          setError(null);
        }
      };

      module.hot.addStatusHandler(hotReloadHandler);
      return function () {
        module.hot.removeStatusHandler(hotReloadHandler);
      };
    }
  });

  return _react["default"].createElement(Catch, {
    onCatch: setError
  }, error ? _react["default"].createElement("pre", {
    style: {
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: '#222',
      color: 'white',
      margin: 0,
      padding: '1rem',
      overflow: 'scroll',
      fontSize: '14px'
    }
  }, "An internal error occured!\n\n".concat(process.env.NODE_ENV === 'production' ? 'Please see the console for more details.' : error.stack, "\n          ")) : _react["default"].createElement(ResolvedRoot, null, children));
}

var Catch =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Catch, _React$Component);

  function Catch() {
    (0, _classCallCheck2["default"])(this, Catch);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Catch).apply(this, arguments));
  }

  (0, _createClass2["default"])(Catch, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.props.onCatch(error);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return Catch;
}(_react["default"].Component);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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